(() => {
  'use strict';

  const element = document.getElementById('lp-cart-bundle-config');
  if (!element) return;

  let config;
  try {
    config = JSON.parse(element.textContent);
  } catch {
    return;
  }

  const wizz = window._wizz;
  if (!Array.isArray(wizz?.campaigns)) return;

  const campaign = wizz.campaigns.find(item => String(item.id_campaign) === String(config.campaignId));
  if (!campaign || campaign.type !== 'volume' || campaign.trigger_type !== 'products' || campaign.logic !== 'OR') return;

  const variantId = String(config.variantId);
  const variants = (campaign.trigger_products || []).flatMap(product => product.variants || []);
  if (!variants.length || variants.some(variant => String(variant.id) !== variantId)) return;

  const thresholds = (campaign.discount_tiers || [])
    .map(tier => Number(tier.trigger_quantity))
    .filter(quantity => Number.isFinite(quantity) && quantity > 0);
  if (!thresholds.length) return;

  const minimumQuantity = Math.min(...thresholds);
  let suppressed = false;

  const sync = items => {
    if (!Array.isArray(items) || !Array.isArray(wizz.campaigns)) return;

    const matching = items.filter(item => String(item.variant_id || item.id) === variantId);
    const isSubscription = item => item.subscription === true || Boolean(item.selling_plan_allocation);
    const hasSubscription = matching.some(isSubscription);
    const oneTimeQuantity = matching
      .filter(item => !isSubscription(item))
      .reduce((total, item) => total + Number(item.quantity || 0), 0);
    const shouldSuppress = hasSubscription && oneTimeQuantity < minimumQuantity;
    const isCampaign = item => String(item.id_campaign) === String(config.campaignId);

    if (shouldSuppress) {
      wizz.campaigns = wizz.campaigns.filter(item => !isCampaign(item));
      suppressed = true;
    } else if (suppressed) {
      if (!wizz.campaigns.some(isCampaign)) wizz.campaigns = [...wizz.campaigns, campaign];
      suppressed = false;
    }
  };

  sync(config.items);
  document.addEventListener('theme:cart:change', event => sync(event.detail?.cart?.items));
})();
